import React from 'react';
import ReportPageWithMonthWeekSwitch from './components/ReportPageWithMonthWeekSwitch';
import KeysByMonthByUploadingUserList from './components/month/KeysByMonthByUploadingUserList';
import KeysByWeekByUploadingUserList from './components/week/KeysByWeekByUploadingUserList';

function KeysByUploadingUser() {
  return (
    <ReportPageWithMonthWeekSwitch
      title="Keys by uploading user"
      MonthList={KeysByMonthByUploadingUserList}
      WeekList={KeysByWeekByUploadingUserList}
    />
  );
}

export default KeysByUploadingUser;
